<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                passive
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('config.add_notification') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="51%"
            :close-on-click-modal="false"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card">
              <div class="card-body">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('config.notification') }}: </strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.associated_modules') }}:
                          </strong>
                        </h6>
                        {{
                          rowData.module ? rowData.module.name : 'No asignado'
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-3">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="business in rowData.businesses"
                          :key="business.id"
                        >
                          <el-tag type="info">
                            {{ business.name }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-3">
                          <strong
                            >{{ $t('common_words.associated_users2') }}:</strong
                          >
                        </h6>
                        <span v-for="user in rowData.users" :key="user.id">
                          <el-tag type="info">
                            {{ user.username }}
                          </el-tag>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            :title="title"
            :visible.sync="modals.create"
            :close-on-click-modal="false"
          >
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    ref="name"
                    type="text"
                    :label="`${$t('common_words.name')} *`"
                    v-model="notificationForm.name"
                    name="common_words.name"
                    v-validate="modelValidations.name"
                    :error="getError('common_words.name', true)"
                    :placeholder="`${$t('config.notification')}...`"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.select_a_module') }} *</label
                    >
                    <br />
                    <el-select
                      clearable
                      class="select-primary custom-width-select required-modules shadow-sm"
                      size="large"
                      v-model="notificationForm.module_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in modules"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_one_or_many_users')
                    }}</label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('notificationForm.users_id', users)
                      "
                      collapse-tags
                      clearable
                      multiple
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      v-model="notificationForm.users_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in this.users"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="`${option.username}`"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none">{{
                      $t('common_words.select_companies')
                    }}</label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect(
                          'notificationForm.businesses_id',
                          business
                        )
                      "
                      collapse-tags
                      id="bussiness_obs"
                      clearable
                      multiple
                      class="select-primary custom-width-select shadow-sm"
                      size="large"
                      v-model="notificationForm.businesses_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in business"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>

              <el-table-column
                min-width="110"
                prop="props.users"
                :label="$t('common_words.associated_users')"
                :align="'center'"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.users.length > 0"
                    :hidden="scope.row.users.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.users.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.users[0].first_name }}
                      {{ scope.row.users[0].last_name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>

              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import configTable from './NotificationTable';
import SweetAlert from 'src/class/Alerts';
import i18n from '../../../../i18n';

export default {
  components: {
    LPagination,
  },

  computed: configTable.search,

  data() {
    return {
      users: null,
      business: null,
      modules: null,
      modals: {
        read: false,
        create: false,
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      notificationForm: {
        id: null,
        route: null,
        name: null,
        module_id: null,
        businesses_id: [],
        users_id: [],
      },
      rowData: {},
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu, MixinForm],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.users = this.concatAll(this.users.splice(1), 'username');
      this.business = this.concatAll(this.business.splice(1));
    },

    openModal(name) {
      if (name == 'create') {
        sessionStorage.removeItem('editForm');
        this.title = i18n.t('config.add_notification');
        this.$validator.reset();
        this.notificationForm.name = null;
        this.notificationForm.module_id = null;
        this.notificationForm.users_id = null;
        this.notificationForm.businesses_id = null;
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (
          this.notificationForm.module_id == null ||
          this.notificationForm.module_id.length == 0
        ) {
          return this.validationInputsRequired('modules');
        }

        if (isValid) {
          this.addNotification();
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = 'notifications';
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.title = i18n.t('config.edit_notification') + ' ' + row.name;
      this.notificationForm = Object.assign({}, row);
      this.errors.clear();
      this.notificationForm.route = 'notifications';
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.notificationForm = row;
      SweetAlert.delete(this.notificationForm.name).then((result) => {
        if (result.value) this.deleteNotification();
      });
    },

    deleteNotification() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.notificationForm.route = 'notifications';
        // this.notificationForm.user_id = store.state.auth.user.id;
        Axios.destroyMaster(this.notificationForm)
          .then((response) => {
            this.modifyTable(2, this.notificationForm.id, response);
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.danger(
              error.response.data.message ? error.response.data.message : error
            );
          });
      }
    },

    addNotification() {
      this.showHideLoading(true);
      this.notificationForm.route = 'notifications';
      if (this.isCreate() && !sessionStorage.getItem('editForm')) {
        // this.notificationForm.user_id = store.state.auth.user.id;
        Axios.saveMaster(this.notificationForm)
          .then((response) => {
            this.modifyTable(0, null, response);
          })
          .catch((error) => {
            this.closeModal('create');
            this.showNotification(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              `${i18n.t('common_words.alert')}...`
            );
            this.showHideLoading();
          });
      } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        this.notificationForm.id = JSON.parse(
          sessionStorage.getItem('editForm')
        ).id;
        // this.notificationForm.user_id = store.state.auth.user.id;
        Axios.updateMaster(this.notificationForm)
          .then((response) => {
            this.modifyTable(1, this.notificationForm.id, response);
            sessionStorage.removeItem('editForm');
          })
          .catch((error) => {
            this.closeModal('create');
            this.showNotification(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              `${i18n.t('common_words.alert')}...`
            );
            this.showHideLoading();
            sessionStorage.removeItem('editForm');
          });
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'notifications/pdf';
      data.name_file = `${i18n.t('config.notification')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'notifications/excel';
      data.name_file = `${i18n.t('config.notification')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('notifications'),
        Axios.getMasters('businesses/only'),
        Axios.getMasters('modules/indexfield'),
        Axios.getMasters('users/indexfieldallusers'),
      ])
        .then((response) => {
          const [
            response_notifications,
            response_businesses,
            response_modules,
            response_users,
          ] = response;
          this.business = this.concatAll(response_businesses.data.data);
          this.modules = response_modules.data.data;
          this.users = this.concatAll(response_users.data.data, 'username');
          this.tableData = response_notifications.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('notifications');
  },

  destroyed() {
    this.deselectedItemOnMenu('notifications');
  },
};
</script>
